import { render, staticRenderFns } from "./LocationPermissionModal.vue?vue&type=template&id=08e7568a&scoped=true&"
import script from "./LocationPermissionModal.vue?vue&type=script&lang=js&"
export * from "./LocationPermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./LocationPermissionModal.vue?vue&type=style&index=0&id=08e7568a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7568a",
  null
  
)

export default component.exports